/**
 * Module Dependencies
 */
import React from 'react';

import AutoAddress from './AutoAddress/AutoAddress';
import ManualAddress from './ManualAddress';

class Address extends React.Component {
    componentDidMount() {
        const { manualAddressState, field, onManualAddress, personUID } =
            this.props;
        const addressHasBeenFilled =
            !manualAddressState &&
            (field.postcode.value || field.street_line_1.value);
        if (addressHasBeenFilled) {
            onManualAddress(personUID, 0);
        }
    }

    render() {
        const {
            addressIndex,
            field,
            onChange,
            onManualAddress,
            manualAddressState,
            onAddressChange,
            fetchedAddresses,
            onAddressReset,
            personIndex,
            personUID,
            onCountrySelect
        } = this.props;

        const props = {
            addressIndex,
            field,
            onChange,
            onAddressChange,
            onManualAddress,
            onAddressReset,
            manualAddressState,
            personIndex,
            personUID,
            onCountrySelect
        };

        const AddressType = !manualAddressState ? (
            <AutoAddress
                fetchedAddresses={fetchedAddresses}
                onChange={onChange}
                {...props}
            />
        ) : (
            <ManualAddress {...props} />
        );

        return AddressType;
    }
}

export default Address;
